module.exports = __webpack_public_path__ + "assets/img/txt-breadcrumb.df47a922.svg";